import React from 'react'
import Button from '../Styled/Button'
import './hero.css'


const Hero = () => {
    
  return (
    <div className='containerHero' id='homePage'>
      <h1 data-aos="fade-left" data-aos-duration="3000">EthicaLottery</h1>
      <h5 data-aos="fade-left" data-aos-duration="3000">You always win</h5>
      <p data-aos="fade-left" data-aos-duration="3000">More play, more win...more earn</p>
      <Button data-aos="fade-left" data-aos-duration="3000">PLAY NOW</Button>
    </div>
  )
}

export default Hero
